<template>
  <div class="page-container">
    <PageHeader title="部门排行" show-breadcrumb />

    <!-- 搜索面板：按部门筛选 -->
    <SearchPanel>
      <el-select v-model="query.zadId" placeholder="部门" clearable size="small" filterable style="width:160px">
        <el-option v-for="d in deptOptions" :key="d.zadId" :label="d.zadName" :value="d.zadId" />
      </el-select>
      <template #actions>
        <el-button type="primary" icon="el-icon-search" size="small" @click="handleSearch">查询</el-button>
        <el-button icon="el-icon-refresh" size="small" @click="handleReset">重置</el-button>
      </template>
    </SearchPanel>

    <!-- 数据为定时任务落库的聚合结果（非实时）；后端按参与率降序、同率按总积分降序 -->
    <TablePanel title="部门排行榜列表">
      <el-table :data="list" v-loading="loading" size="small" stripe :height="tableHeight">
        <el-table-column label="排名" width="80" align="center">
          <template slot-scope="{ $index }">
            <span :class="['rank-no', $index < 3 ? 'rank-top' + $index : '']">{{ rankText($index) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="zadName" label="部门" min-width="140" align="center" show-overflow-tooltip />
        <el-table-column prop="pusdUserNum" label="参与人数" min-width="100" align="center" />
        <el-table-column label="参与率" min-width="170" align="center">
          <template slot-scope="{ row }">
            <el-progress :percentage="Number(row.pusdUserRate) || 0" :stroke-width="10" :format="p => p + '%'" style="max-width:150px;margin:0 auto" />
          </template>
        </el-table-column>
        <el-table-column prop="pusdPkNums" label="PK场次" min-width="100" align="center" />
        <el-table-column prop="pusdPkWinNums" label="胜场" min-width="90" align="center" />
        <el-table-column label="总积分" min-width="100" align="center">
          <template slot-scope="{ row }"><span style="color:#d69e2e;font-weight:700">{{ row.pusdPointsTotal }}</span></template>
        </el-table-column>
        <el-table-column prop="pusdUserPointsAvg" label="人均积分" min-width="100" align="center" />
      </el-table>
      <el-pagination
        :current-page="page.currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
      />
    </TablePanel>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue'
import SearchPanel from '@/components/SearchPanel.vue'
import TablePanel from '@/components/TablePanel.vue'
import { getPkqUserStatisticsDtList, getZqpkAuthDepartmentList } from '@/api/api'

export default {
  name: 'PkqUserStatisticsDt',
  components: { PageHeader, SearchPanel, TablePanel },
  data () {
    return {
      loading: false,
      tableHeight: 400,
      list: [],
      deptOptions: [],
      query: { zadId: null },
      page: { currentPage: 1, pageSize: 10, total: 0 }
    }
  },
  created () { this.fetchList(); this.fetchDepartments() },
  mounted () {
    this.$nextTick(this.calcTableHeight)
    window.addEventListener('resize', this.calcTableHeight)
  },
  beforeDestroy () { window.removeEventListener('resize', this.calcTableHeight) },
  methods: {
    // 前三名奖牌标识，其余显示数字名次（列表顺序即后端排名）
    rankText (idx) {
      return ['🥇', '🥈', '🥉'][idx] || (idx + 1)
    },
    calcTableHeight () {
      const el = this.$el.querySelector('.el-table')
      if (!el) return
      this.tableHeight = window.innerHeight - el.getBoundingClientRect().top - 80
    },
    // 部门下拉数据（部门量不大，一次取全量）
    async fetchDepartments () {
      try {
        const res = await getZqpkAuthDepartmentList({ currentPage: 1, pageSize: 500 })
        this.deptOptions = res.data || []
      } catch (e) { this.deptOptions = [] }
    },
    async fetchList () {
      this.loading = true
      try {
        const params = { currentPage: this.page.currentPage, pageSize: this.page.pageSize }
        if (this.query.zadId !== null && this.query.zadId !== undefined) params.zadId = this.query.zadId
        const res = await getPkqUserStatisticsDtList(params)
        this.list = res.data || []
        this.page.total = res.total || 0
      } catch (e) { this.list = []; this.page.total = 0 } finally { this.loading = false }
    },
    handleSearch () { this.page.currentPage = 1; this.fetchList() },
    handleReset () { this.query = { zadId: null }; this.handleSearch() },
    handleSizeChange (size) { this.page.pageSize = size; this.handleSearch() },
    handlePageChange (page) { this.page.currentPage = page; this.fetchList() }
  }
}
</script>

<style lang="scss" scoped>
.rank-no { font-weight: 600; color: #475569; }
.rank-top0, .rank-top1, .rank-top2 { font-size: 18px; }
</style>
